import React from 'react';
import { CardActions } from 'material-ui/Card';
import { CreateButton, FilterButton, ClearFilterButton } from '../button';
import onlyUpdateForKeys from 'recompose/onlyUpdateForKeys';

import DownloadIcon from 'material-ui/svg-icons/action/get-app'


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const Actions = ({ resource, custom_button, hasCreate, hasClearFilter, hasExport, onExport, basePath, refresh }) => (
    <CardActions style={cardActionStyle}>
        {custom_button && React.cloneElement(custom_button, {
            basePath: basePath
        })}
        {hasCreate && <CreateButton basePath={basePath}/>}
        <FilterButton/>
        {hasExport && <FilterButton
            label="Export"
            resource={resource}
            isExport={true}
            onExport={onExport}
            icon={<DownloadIcon/>}
        />}
        {hasClearFilter && <ClearFilterButton resource={resource}/>}
    </CardActions>
);

export default onlyUpdateForKeys(['resource', 'hasClearFilter', 'filters', 'filterValues'])(Actions);



// WEBPACK FOOTER //
// ./src/components/list/Actions.js